module.exports = "/lucky-balls/img/combos-sr/6.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos-sr/6.png
// module id = 991
// module chunks = 0